
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disclosures",
      function () {
        return require("private-next-pages/disclosures.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disclosures"])
      });
    }
  